import React from 'react';
export function Bonuses() {
  const bonuses = [{
    title: 'Checklist de Clase de Emergencia',
    value: '7€'
  }, {
    title: 'Guía de Selección Musical PRO',
    value: '9€'
  }, {
    title: 'Fichas de Seguimiento y Progreso',
    value: '7€'
  }, {
    title: 'Syllabus de 12 Semanas',
    value: '12€'
  }, {
    title: 'Plantillas de Marketing y Copy',
    value: '7€'
  }, {
    title: 'Diccionario de Terminología PRO',
    value: '5€'
  }];
  return <section className="bg-black py-12 px-4" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-4 text-center" data-id="element-39">
          🔥 6 Bonos Exclusivos Incluidos
        </h2>
        <p className="text-center text-white font-medium mb-12 font-heading" data-id="element-40">
          Valor combinado: 47€ — Gratis hoy
        </p>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-41">
          {bonuses.map((bonus, i) => <div key={i} className="flex items-center justify-between p-4 rounded-lg border border-white/20 hover:border-white/40 transition-colors bg-white/5" data-id="element-42">
              <span className="text-white" data-id="element-43">{bonus.title}</span>
              <span className="text-brand-cta font-medium" data-id="element-44">{bonus.value}</span>
            </div>)}
        </div>
      </div>
    </section>;
}